var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"site-name"},[_vm._v(" Spotlight "),_c('div',{staticClass:"sub"},[_vm._v("On Skills")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }